import { useMutation } from '@tanstack/react-query';
import { IOperationResultNoValue } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidatePhoneNumberUserQuery } from './usePhoneNumberUserQuery';

export function usePhoneNumberDeleteCallForwardingMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: () => void;
	onError?: (error: IOperationResultNoValue) => void;
}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ id }: { id: string }) => {
			return userSession.webServiceHelper.callAsync(`phoneNumber/${id}/callForwardingNumber`, 'DELETE');
		},
		onSuccess,
		onError,
		onSettled: () => {
			invalidatePhoneNumberUserQuery();
		},
	});
}
